<template>
    <div>
        <b-overlay :show="items_being_loaded" rounded="sm">
            PULLED AT:
             <b-form-select
                v-model="picked_pull_location"
                :options="locations" 
                size="sm" 
                style="width: 150px;"
            ></b-form-select>


            GROUP BY:
             <b-form-select
                :options="group_keys" 
                size="sm" 
                style="width: 150px;"
                v-on:change="setGroup"
            ></b-form-select>

            <div v-if="groups.length > 0">

                <div style="margin: 10px;">
                
            
<!--                     Destination:
                     <b-form-select
                        v-model="picked_location"
                        :options="locations" 
                        size="sm" 
                        style="width: 150px;"
                    ></b-form-select> -->

                    
                </div>
                <div v-for="group, gidx in groups" style="margin: 10px;">
                    {{ group.key }}
                    <table style="width: 100%;">

                        <thead>
                            <tr style="background: black; color: white;">
                                
                                <td class="ipt_tdhr" v-on:click="sortby('pulled_ts')">
                                    PULLD BY
                                </td>

                                <td class="ipt_tdhr" v-on:click="sortby('pullist_name')">
                                    PULLIST
                                </td>

                                <td class="ipt_tdhr" v-on:click="sortby('pull_location_id')">
                                    PULLED AT
                                </td>

                                <td class="ipt_tdhr" v-on:click="sortby('location_id')">
                                    DEST
                                </td>
                                
                                <td class="ipt_tdhr">
                                    PRD
                                </td>
                                
                                <td class="ipt_tdhr">
                                    PLD QTY
                                </td>

                                <td class="ipt_tdhr">
                                    SHPD QTY
                                </td>

                                <td class="ipt_tdhr">
                                    STATUS
                                </td>

                                <td class="ipt_tdhr">
                                    ACTION
                                </td>
                            </tr>

                        </thead>

                        <tbody>
                            <tr v-for="item, idx in group.items" v-if="showRow(gidx, idx)">

                                <td class="ipt_tdr">
                                    {{ item.pulled_ts }}
                                </td>

                                <td class="ipt_tdr">
                                    {{ item.pullist_name }}
                                </td>

                                <td class="ipt_tdr">
                                    <div>{{ locationsdict[item.pull_location_id] }}</div>
                                    <div>{{ sublocationsdict[item.pull_sublocation_id]}}</div>
                                </td>

                                <td class="ipt_tdr">
                                    <div>{{ locationsdict[item.location_id] }}</div>
                                    <div>{{ sublocationsdict[item.sublocation_id]}}</div>
                                </td>

                                <td class="ipt_tdr">
                                    <div>{{ item.product_sku }}</div>
                                    <div>{{ item.vendor }} ({{ item.category }})</div>
                                    <b-badge variant="success" v-if="item.invoice_id">sale # {{ item.invoice_id}}</b-badge>
                                </td>
                                
                                <td class="ipt_tdr" style="width: 50px;">
                                    {{ item.pulled_quantity }}
                                </td>

                                <td class="ipt_tdr" style="width: 50px;">
                                    <input v-model="item.shipped_quantity" :style="{width: '45px', 'background': (( item.shipped_quantity == null || item.shipped_quantity == '') ? '#fdcb6e' : 'orange'), 'padding': '3px', margin: 'auto', border: '1px solid #737373', 'border-radius': '2px'}"></input>
                                </td>

                                <td class="ipt_tdr" :style="{background: tr_item_statuses_colors[item.status] }">
                                    {{ tr_item_statuses_dict[item.status] }}
                                </td>

                                <td class="ipt_tdr" style="width: 110px;">
                                    <span v-if="item.status == 3">
                                        <b-badge variant="success" style="padding: 5px; font-size: 14px; font-weight: bold; cursor: pointer;" @click="markItemAsShipped(idx)" :disabled="actions_disabled">Mark Shipped</b-badge>
                                    </span>
                                    <span v-else-if="item.status == 4">
                                        <b-badge variant="primary" style="padding: 5px; font-size: 14px; font-weight: bold; cursor: pointer;" @click="markItemAsShipped(idx)" :disabled="actions_disabled">Update</b-badge>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <b-alert v-else show variant="warning">No items in the pulled state</b-alert>
        </b-overlay>
    </div>
</template>

<script>
    import global_vars from '@/utilities/global_vars'
    import moment from 'moment'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    export default {
        name: "PulledItems",
        props: ["showbacker"],
        components: {Backer},
        data: function(){
            return {
                userDetails: {properties: {}},
                tr_item_statuses: global_vars.TRANSFER_STATUSES,
                tr_item_statuses_colors: global_vars.TRANSFER_STATUSES_COLORS_DICT,
                tr_item_statuses_dict: global_vars.TRANSFER_STATUSES_DICT,
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                locsubs: [],
                items: [],
                items_being_loaded: false,
                picked_location: null,
                picked_pull_location: null,
                sort_asc: true,
                actions_disabled: false,
                groups: [],
                group_keys: [
                    {value:"ALL", text: "ALL"},
                    {value: "by_pullist", text: "By Pullist"},
                    {value: "by_pull_location", text: "By Pull Location"},

                ]
            }
        },
        methods: {
            showRow: function(gidx, idx){
                let item = this.groups[gidx].items[idx];
                let allow_picked_location = this.allow_picked_location(item);
                let allow_picked_pull_location = this.allow_picked_pull_location(item);

                if (allow_picked_location == true && allow_picked_pull_location == true){
                    return true
                }
                else {
                    return false
                }
            },
            allow_picked_location: function(item){
                if (this.picked_location == null){
                    return true
                }
                else {
                    if (item.location_id == this.picked_location){
                        return true
                    }
                    else {
                        return false
                    }
                }
            },
            allow_picked_pull_location: function(item){
                if (this.picked_pull_location == null){
                    return true
                }
                else {
                    if (item.pull_location_id == this.picked_pull_location){
                        return true
                    }
                    else {
                        return false
                    }
                }
            },
            markItemAsShipped: function(idx){
                let item = this.items[idx];
                let that = this;
                
                if (isNaN(parseInt(item.shipped_quantity))){
                    this.$vex.dialog.alert({message: "Please specify a valid numerical quantity for shipped."});
                    return
                }
                
                item.shipped_quantity = parseInt(item.shipped_quantity);
                if (item.shipped_quantity > item.pulled_quantity ){
                    this.$vex.dialog.alert({message: "# of shipped items cannot be more than what is pulled."});
                    return
                }

                let data = {
                    tr_id: item.tr_id, 
                    itemid: item.itemid, 
                    shipped_quantity: item.shipped_quantity, 
                    shipped_by: this.userDetails.username
                }
                let path = "/api/inventory/mark_tr_item_shipped/"
                let s = function(response){
                    if (response.data.error){
                        that.$vex.dialog.alert({message: response.data.error});
                    }
                    else {
                        that.$bvToast.toast(
                            "Item successfully marked as shipped.", 
                            {title: "Succes", autoHideDelay: 1500, variant:"success"}
                        );

                        that.items[idx].status = 4;
                    }
                    that.actions_disabled = false;
                }

                let f = function(error){
                    console.log(error);
                    that.$vex.dialog.alert({message: "Error marking the item as shipped."});
                    that.actions_disabled = false;
                }

                this.actions_disabled = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            setGroup: function(key){
                if (key == "ALL"){
                    let items = [];
                    for (var i=0; i<this.groups.length; i++){
                        let grp = this.groups[i].items;
                        for (var j=0; j<grp.length; j++){
                            items.push(grp[j]);
                        }
                    }
                    this.groups = [{key: "ALL", items: items}]
                    return
                }
                else if (key == "by_pullist"){
                    let groups = {};
                    for (var i=0; i<this.groups.length; i++){
                        let grp = this.groups[i];
                        for (var j=0; j<grp.items.length; j++){
                            if (grp.items[j].pullist_name in groups){
                                groups[grp.items[j].pullist_name].push(grp.items[j])
                            }
                            else {
                                groups[grp.items[j].pullist_name] = [grp.items[j]];
                            }
                        }
                    }

                    //now fill
                    this.groups = Object.keys(groups).map(e => { return { key:e, items: groups[e] } });
                    return
                }

                else if (key == "by_pull_location"){
                    let groups = {};
                    for (var i=0; i<this.groups.length; i++){
                        let grp = this.groups[i];
                        for (var j=0; j<grp.items.length; j++){
                            let kk = this.locationsdict[grp.items[j].pull_location_id];
                            if ( kk in groups){
                                groups[kk].push(grp.items[j])
                            }
                            else {
                                groups[kk] = [grp.items[j]];
                            }
                        }
                    }
                    //now fill
                    this.groups = Object.keys(groups).map(e => { return { key:e, items: groups[e] } });
                    return
                }
            },
            fetch_prereqs: function(){
                let that = this;

                let prereqs = [
                    {
                        path:  "/api/user/get_tools_packet/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.locations.map(function(d){
                                    return {value: d.id, text: d.name}
                                });
                                that.locations.splice(0, 0, {value: null,  text: "All"});
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.sublocations = response.data.result.sublocations.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.locsubs = response.data.result.locsubs;

                                that.fetch_init();
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            fetch_init: function(){
                let that = this;
                let path = "/api/inventory/get_tr_items_pulled/"
                let data = {}
                let s = function(response){
                    console.log(response)
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.groups = [{items: response.data.result, key: "ALL"}]
                        console.log(that.groups)
                        //that.items = response.data.result
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading ready items.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();
                
            }
        }
    }
</script>

<style scoped>
    .new_tr_label_box {
        display: inline-block;
        margin: 10px;
        width: auto;
        border: 1px solid;
        padding: 5px;
        font-size: 14px;
        background: #e5ffb1;
    }

    td {
        padding: 1px;
        font-size: 14px;
    }

    select {
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/PulledItems.vue